import React, { useState } from "react";
import { trackedLinkHref, resolveImageUrl } from "../utils/linkImage";

// gap-3 is 0.75rem, so a tile in a pair is 50% of the container minus half the gap.
const LONE_TILE_WIDTH = "calc(50% - 0.375rem)";
const MAX_TILE_RADIUS = 24;

// Theme cards can be pills (9999px); on a square tile that would become a circle, so cap it.
const tileRadius = (radius) => {
  const px = parseFloat(radius);
  return Number.isNaN(px) ? "16px" : Math.min(px, MAX_TILE_RADIUS) + "px";
};

const clamp2 = {
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
};

const Tile = ({ item, themeSurface, lone, preview }) => {
  const [failed, setFailed] = useState(false);
  const { card } = themeSurface;
  const Wrapper = preview ? "div" : "a";
  const linkProps = preview
    ? {}
    : { href: trackedLinkHref(item), target: "_blank", rel: "noopener noreferrer" };

  return (
    <Wrapper
      {...linkProps}
      className={
        "group relative block aspect-square overflow-hidden transition-transform duration-200 " +
        (preview ? "" : "hover:-translate-y-0.5 ") +
        (lone ? "col-span-2 justify-self-center" : "")
      }
      style={{
        // Only the theme's shape (radius, border, hard/glow shadow); the photo replaces the fill.
        borderRadius: tileRadius(card.borderRadius),
        border: card.border,
        boxShadow: card.boxShadow,
        background: card.background,
        width: lone ? LONE_TILE_WIDTH : undefined,
      }}
    >
      {item.image_url && !failed && (
        <img
          src={resolveImageUrl(item.image_url)}
          alt={item.social_name || ""}
          loading="lazy"
          className="w-full h-full object-cover"
          onError={() => setFailed(true)}
        />
      )}
      {item.social_name && (
        <span
          className={
            "absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent text-white font-medium leading-snug text-left " +
            (preview ? "px-2 pt-6 pb-1.5 text-[10px]" : "px-3 pt-10 pb-2.5 text-sm")
          }
          style={clamp2}
        >
          {item.social_name}
        </span>
      )}
    </Wrapper>
  );
};

// One run of consecutive image links. Always 2 columns; an odd last tile (or a lone one)
// is centered on its own row at the same width as a paired tile.
const ImageLinkGrid = ({ items, themeSurface, preview = false }) => (
  <div className="grid grid-cols-2 gap-3">
    {items.map(({ item, index }, i) => (
      <Tile
        key={index}
        item={item}
        themeSurface={themeSurface}
        preview={preview}
        lone={items.length % 2 === 1 && i === items.length - 1}
      />
    ))}
  </div>
);

export default ImageLinkGrid;
